// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgArrowDown24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.75 4.75C12.75 4.33579 12.4142 4 12 4C11.5858 4 11.25 4.33579 11.25 4.75V17.439L6.53033 12.7197C6.23744 12.4268 5.76256 12.4268 5.46967 12.7197C5.17678 13.0126 5.17678 13.4874 5.46967 13.7803L11.4697 19.7803C11.7626 20.0732 12.2374 20.0732 12.5303 19.7803L18.5303 13.7803C18.8232 13.4874 18.8232 13.0126 18.5303 12.7197L18.4462 12.6471C18.1526 12.4292 17.7359 12.4534 17.4697 12.7197L12.75 17.439V4.75Z"
				/>
			</Svg>
		);
	}
);
SvgArrowDown24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgArrowDown24;
